import React from 'react'
import { ICvrOption, ICvrLookup } from './types'
import AutocompleteBase from '../AutocompleteBase/AutocompleteBase'
import { FieldType } from '../../utils/fieldTypeEnum'
import { getOptionLabel, getOptionSelected, modelData, urlBuilder } from './CvrUtils'

export const CvrLookup: React.FC<ICvrLookup> = ({
  variant = 'lite',
  name,
  label,
  fieldType,
  fieldWidth,
  searchMaxSize = '25',
  disabled,
  required,
  popover,
  labelOptions,
  assistiveText,
  ...props
}) => {
  if (fieldType != FieldType.CVR) throw Error('CVR field needs to be a cvr field. . .🤦‍♂️')

  return (
    <AutocompleteBase<ICvrOption>
      {...props}
      urlBuilder={(searchTerm: string) => urlBuilder(searchTerm, searchMaxSize, variant)}
      getOptionLabel={(option: ICvrOption) => getOptionLabel(option, variant, labelOptions)}
      getOptionSelected={getOptionSelected}
      modelData={modelData}
      name={name}
      label={label}
      fieldType={fieldType}
      fieldWidth={fieldWidth}
      disabled={disabled}
      required={required}
      popover={popover}
      assistiveText={assistiveText}
    />
  )
}
